// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { OperatorConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Operator';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useRegistryOperatorConfiguration: () => UseQueryResult<
  TemplateContract<OperatorConfiguration> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOffset({
    queryKey: ['queryRegistryOperatorConfiguration', operator],
    enabled: !!operator,
    queryFn: async (_, offset) => {
      return ledgerApi.queryRegistryOperatorConfiguration(offset, operator);
    },
  });
};

export default useRegistryOperatorConfiguration;
